<template>
  <div>
    <Table :columns="columns" :data="tableData">
      <template slot-scope="{ row }" slot="berecommendname_staffNo">
        <div class="name-status">
          <div class="user-box">
            <i class="dian" :class="{ red: row.beRecommendedWorkingState == 0, orange: row.beRecommendedIsSus == 1 }" v-if="row.beRecommendedName"></i>
            <span class="user-name">{{ row.beRecommendStaffNo }}</span>
            <span v-if="row.beRecommendStaffNo">/</span>
            <span class="user-name">{{ row.beRecommendedName }}</span>
          </div>
        </div>
      </template>
    </Table>
    <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getListData" style="text-align: center; margin-top: 20px" />
  </div>
</template>

<script>
import { common, pageTool } from '@/api/mixins';
export default {
  props: ['actId', 'productType'],
  mixins: [common, pageTool],
  data() {
    return {
      columns: [
        {
          title: '被推荐人',
          minWidth: 250,
          align: 'center',
          slot: 'berecommendname_staffNo'
        },
        {
          title: '被推荐人手机号',
          key: 'beRecommendedMobile',
          minWidth: 150,
          align: 'center',
          render(h, params) {
            let beRecommendedMobile = params.row.beRecommendedMobile;
            return <span>{beRecommendedMobile ? beRecommendedMobile : '-'}</span>;
          }
        },
        {
          title: '保单号',
          key: 'policyNo',
          minWidth: 150,
          align: 'center',
          render(h, params) {
            let policyNo = params.row.policyNo;
            return <span>{policyNo ? policyNo : '-'}</span>;
          }
        },
        {
          title: '签约状态',
          minWidth: 150,
          align: 'center',
          render(h, params) {
            let recommendType = params.row.recommendType;
            let beRecommendedWorkingState = params.row.beRecommendedWorkingState;
            let beRecommendedIsSus = params.row.beRecommendedIsSus;
            if(recommendType == 1 && beRecommendedWorkingState != '0' && beRecommendedIsSus != 1) {
              return <span>注册</span>;
            } else if (recommendType == 2 && beRecommendedWorkingState != '0' && beRecommendedIsSus != 1) {
              return <span>入职</span>;
            }else if (beRecommendedWorkingState == '0') {
              return <span>离职</span>;
            }else if (beRecommendedIsSus == '1') {
              return <span>停职</span>;
            }
          }
        },
        {
          title: '奖励类型',
          align: 'center',
          minWidth: 120,
          render(h, params) {
            let rewardType = params.row.rewardType;
            if (rewardType == 1) {
              return <span>加费</span>;
            } else if (rewardType == 2) {
              return <span>实物</span>;
            } else {
              return <span>现金</span>;
            }
          }
        }
      ],
      tableData: []
    };
  },
  created() {
    this.getListData();
  },
  methods: {
    getListData() {
      let data = {
        reportId: this.$route.query.reportId,
        type: 14,
        activityId: this.actId,
        userId: this.$route.query.userId,
        pageSize: this.pageSize,
        pageNo: this.pageNum
      };
      this.$http({
        url: '/buz/userSalaryDetails/getDetail',
        type: 'POST',
        data
      }).then(res => {
        this.tableData = res.data;
        this.total = res.total;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.name-status {
  align-items: center;
  /deep/ .user-box {
    font-size: 12px;
    .dian {
      display: inline-block;
      flex-shrink: 0;
      width: 5px;
      height: 5px;
      background: #35bf3f;
      border-radius: 50%;
      margin-right: 4px;
      &.red {
        background: #e3461f;
      }
      &.orange {
        background: #ff9900 !important;
      }
    }
    &.text {
      color: #515c6f;
    }
    .user-name {
      font-size: 13px;
      &.dashed {
        border-bottom: 1px dashed #236dff;
      }
      &.line {
        border-bottom: 1px solid #236dff;
      }
    }
    i {
      color: #bababa;
      font-size: 13px;
    }
  }
}
</style>
